import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";

import { RestroUsers } from "../../../../services/DatabaseService/RestroUsers";
import { BreadCrumb } from "../../component/BreadCrumb";
import { Link, useNavigate } from "react-router-dom";
import CustomDataTable from "../../../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";
import { formatDateTime } from "../../../../Components/Common/FormatDate";

export default function RestroUsersInfo() {
  const router = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [filterTenantName, setFilterTenantName] = useState("");
  const [filterTenantCode, setFilterTenantCode] = useState("");
  const [filterIsActive, setFilterIsActive] = useState(null);
  const [registeredDateRange, setRegisteredDateRange] = useState([]);
  const [validDateRange, setValidDateRange] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [filterBoolean, setFilterBoolean] = useState(true);

  const fetchData = async (
    tenantName = filterTenantName,
    tenantCode = filterTenantCode,
    status = filterBoolean,
    registeredStart,
    registeredEnd,
    validStart,
    validEnd
  ) => {
    // console.log(status)
    setLoading(true);
    try {
      console.log(registeredStart, registeredEnd);
      console.log("fired");
      const result = await RestroUsers.getAll({
        tenantName: tenantName,
        tenantCode: tenantCode,
        IsActive: status,
        RegisteredDateFrom: registeredStart,
        RegisteredDateTo: registeredEnd,
        ValidDateFrom: validStart,
        ValidDateTo: validEnd,
      });
      console.log(result);
      setDataList(result || []);
    } catch (error) {
      console.error("Failed to load data:", error);
      setDataList([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  let registeredStart, registeredEnd, validStart, validEnd;

  if (registeredDateRange.length === 2) {
    [registeredStart, registeredEnd] = registeredDateRange.map(formatDate);
  }

  if (validDateRange.length === 2) {
    [validStart, validEnd] = validDateRange.map(formatDate);
  }

  useEffect(() => {
    if (registeredDateRange.length === 2 || validDateRange.length === 2) {
      let registeredStart, registeredEnd, validStart, validEnd;

      if (registeredDateRange.length === 2) {
        [registeredStart, registeredEnd] = registeredDateRange.map(formatDate);
      }

      if (validDateRange.length === 2) {
        [validStart, validEnd] = validDateRange.map(formatDate);
      }

      fetchData(
        filterTenantName,
        filterTenantCode,
        filterBoolean,
        registeredStart,
        registeredEnd,
        validStart,
        validEnd
      );
    }
  }, [
    registeredDateRange,
    validDateRange,
    filterTenantName,
    filterTenantCode,
    filterBoolean,
  ]);

  // Unified fetch function

  useEffect(() => {
    fetchData(filterTenantName, filterTenantCode);
  }, [filterTenantName, filterTenantCode]);

  const [addModal, setAddModal] = useState(false);

  const filteredData = dataList.filter(
    (item) =>
      (item.name?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || ""
      ) ||
      (item.database?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || ""
      )
  );

  const customStyles = {
    headCells: {
      style: {
        fontSize: "0.92rem",
        fontWeight: 610,
        width: "max-content",
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };

  const columns = [
    {
      name: "S No",
      cell: (row, index) => <div className=" pe-4">{index + 1}</div>,
      width: "90px",
      sortable: true,
      center: true,
    },
    {
      name: "Name",
      selector: (row) => row.tenantName,
      sortable: true,
      width: "210px",
      cell: (row) => (
        <div style={{ whiteSpace: "nowrap" }}>
          <strong>{row.tenantName}</strong>
          <br />
          <small className="text-muted">{row.tenantCode}</small>
        </div>
      ),
    },

    {
      name: "Address",
      selector: (row) => <span title={row.address} className="d-block text-wrap text-break">
          {row.address}
        </span>,
      sortable: true,
    },
    {
      name: "Registered Date",
      selector: (row) => formatDateTime(row.regsiteredDate),
      cell: (row) => {
        const dateObj = new Date(row.validTill);
        const date = dateObj.toLocaleDateString("en-GB"); // e.g., 26/09/2025
        const time = dateObj.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }); // e.g., 07:42:10

        return (
          <div>
            {date}
            <br />
            {time}
          </div>
        );
      },
      sortable: true,
    },

    {
      name: "Phone No",
      selector: (row) =><span title={row.phone} className="d-block text-break">{row.phone}</span> ,
      sortable: true,
    },
    {
      name: "Valid Till",
      selector: (row) => formatDateTime(row.validTill),
      sortable: true,
      cell: (row) => {
        const dateObj = new Date(row.validTill);
        const date = dateObj.toLocaleDateString("en-GB"); // e.g., 26/09/2025
        const time = dateObj.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }); // e.g., 07:42:10

        return (
          <div>
            {date}
            <br />
            {time}
          </div>
        );
      },
    },
    {
      name: "Status",
      selector: "isActive",
      sortable: true,
      width: "105px",
      cell: (row) => (
        <button
          className={`btn btn-sm ${
            row.isActive ? "btn-success" : "btn-danger"
          }`}
          onClick={() => console.log("Button clicked for", row)}
        >
          {row.isActive ? "Active" : "Inactive"}
        </button>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <Link to={`/restrouserinfo/update/${row.apiKey}`}>
            <Button color="btn btn-soft-warning" className="btn-sm ms-1">
              <i className="ri-edit-line " />
            </Button>
          </Link>

          <Link to={`/restrolog/detail/${row.apiKey}`}>
            <Button color="btn btn-soft-success" className="btn-sm ms-1">
              <i className="ri-eye-line" />
            </Button>
          </Link>

          <Link to ={`/restrouserinfo/extend/${row.apiKey}`}>
          <Button color = "btn btn-soft-info" className="btn-sm ms-1">
            <i className="ri-time-line"/>
          </Button>
          </Link>
        </div>
      ),
      center: true,
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Restro User Info" pageTitle="Database" />
      </div>

      {/* Filters */}
      <Row className="mb-3 align-items-end">
        <Col md={3} className="mb-2">
          <Input
            placeholder="Search by TenantName"
            value={filterTenantName}
            onChange={(e) => setFilterTenantName(e.target.value)}
          />
        </Col>

        <Col md={3} className="mb-2">
          <Input
            placeholder="Search by TenantCode"
            value={filterTenantCode}
            onChange={(e) => setFilterTenantCode(e.target.value)}
          />
        </Col>

        <Col md={2} className="mb-2">
          <Flatpickr
            className="form-control"
            placeholder="Registered Date"
            value={registeredDateRange}
            onChange={(dates) => setRegisteredDateRange(dates)}
            options={{
              mode: "range",
              dateFormat: "Y-m-d",
            }}
          />
        </Col>

        <Col md={2} className="mb-2">
          <Flatpickr
            className="form-control"
            placeholder="Valid Date"
            value={validDateRange}
            onChange={(dates) => setValidDateRange(dates)}
            options={{
              mode: "range",
              dateFormat: "Y-m-d",
            }}
          />
        </Col>

        <Col md={1} className="mb-2 d-flex align-items-center">
          <div className="form-check mb-0">
            <input
              className="form-check-input"
              type="checkbox"
              id="filterBoolean"
              checked={filterBoolean}
              onChange={(e) => {
                const newValue = !filterBoolean;
                setFilterBoolean(newValue);
                fetchData(filterTenantName, filterTenantCode, newValue);
              }}
            />
            <label className="form-check-label pb-2" htmlFor="filterBoolean">
              Active
            </label>
          </div>
        </Col>
      </Row>

      {/* Desktop Table */}
      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData || []}
          />
        </CardBody>
      </Card>

      {/* Mobile Table - Scrollable */}
      <Card className="d-block d-lg-none">
        <CardBody className="p-0">
          <div style={{ overflowX: "auto" }}>
            <CustomDataTable
              responsive
              striped
              pagination
              fixedHeader
              persistTableHead
              progressPending={loading}
              customStyles={customStyles}
              progressComponent={
                <div className="my-3">
                  <Triangle
                    visible={true}
                    height="80"
                    width="80"
                    color="#5B71B9"
                    ariaLabel="triangle-loading"
                  />
                  <h5 className="mt-1">Loading...</h5>
                </div>
              }
              columns={columns}
              data={filteredData || []}
            />
          </div>
        </CardBody>
      </Card>

      {/* Loading State */}
      {loading && (
        <div className="my-5 d-flex justify-content-center">
          <h5 className="mt-1">Loading...</h5>
        </div>
      )}
    </div>
  );
}
